import dayjs from "dayjs"
import { type Reducer } from "redux"

import {
  type OneFleetDevolucaoFormsState,
  OneFleetDevolucaoFormsTypes
} from "./types"

const INITIAL_STATE: OneFleetDevolucaoFormsState = {
  data: {
    car: {
      hasDamageOrMissingItems: false,
      licensePlate: "",
      model: "",
      returnDate: dayjs()
    },
    client: {
      company: "",
      cpf: "",
      email: "",
      name: "",
      phone: "",
      phoneCountryCode: { code: "55", country: "+55 Brasil" }
    },
    consultant: {
      cityAndState: "",
      dealer: "",
      email: "",
      name: "",
      phone: "",
      phoneCountryCode: { code: "55", country: "+55 Brasil" }
    },
    formId: "",
    images: {
      carBackFileList: [],
      carFrontFileList: [],
      carLeftFileList: [],
      carRightFileList: [],
      licensePlateFileList: [],
      odometerFileList: []
    },
    signatures: {
      clientPicture: { name: "", uid: "" },
      clientCNH: { name: "", uid: "" },
      clientSignatureDots: [],
      clientSignatureImage: "",
      consultantSignatureDots: [],
      consultantSignatureImage: ""
    },
    damagedOrMissingItems: {
      carProblemDescription: "",
      accessoriesStatus: {},
      images: {}
    }
  },
  accessoryStatus: [
    { code: 1, name: "OK", isAProblem: false },
    { code: 2, name: "Avariado", isAProblem: true, demandImage: true },
    { code: 3, name: "Falta", isAProblem: true, demandImage: false },
    { code: 4, name: "Não se aplica", isAProblem: false }
  ],
  accessories: [
    { code: 1, name: "Chave Reserva" },
    { code: 2, name: "Manual do Proprietário" },
    { code: 3, name: "Documento do veículo (CRLV)" },
    { code: 4, name: "Ar-Condicionado" },
    { code: 5, name: "Vidros Elétricos" },
    { code: 6, name: "Travas Elétricas" },
    { code: 7, name: "Faróis / Faroletes / Setas" },
    { code: 8, name: "Antena" },
    { code: 9, name: "Freios / Freio de Estacionamento" },
    { code: 10, name: "Tapetes Dianteiros" },
    { code: 11, name: "Tapetes Traseiros" },
    { code: 12, name: "Estepe" },
    { code: 13, name: "Macaco" },
    { code: 14, name: "Chave de Roda" },
    { code: 15, name: "Triângulo" },
    { code: 16, name: "Central Multimídia" }
  ],
  plateInfo: {}
}

const reducer: Reducer<OneFleetDevolucaoFormsState> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case OneFleetDevolucaoFormsTypes.SET_DATA:
      return { ...state, data: { ...state.data, ...action.payload.data } }
    case OneFleetDevolucaoFormsTypes.CLEAR_DATA:
      return { ...state, data: {} }

    case OneFleetDevolucaoFormsTypes.SEARCH_PLATE_REQUEST:
      return { ...state, plateInfo: { loading: true } }
    case OneFleetDevolucaoFormsTypes.SEARCH_PLATE_SUCCESS:
      return { ...state, plateInfo: { data: action.payload, loading: false } }
    case OneFleetDevolucaoFormsTypes.SEARCH_PLATE_FAILURE:
      return {
        ...state,
        plateInfo: { error: true, message: action.payload, loading: false }
      }
    case OneFleetDevolucaoFormsTypes.SEARCH_PLATE_CLEAR:
      return { ...state, plateInfo: { loading: false } }

    default:
      return state
  }
}

export default reducer
